/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/VideoCapture/Error",
  height = 30,
  color = "rgb(50, 50, 50)",
  marginTop = 0,
  marginBottom = 0
  
}) {
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Error.Text"
  data-view-path={viewPath}
 style={{'--fs-1-4QcjJ': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-2-4QcjJ': dtTypographyFontweightRegular,'--lh-3-4QcjJ': dtTypographyLineheightM,'--h-4-4QcjJ': typeof height === 'number' ? `${height}px` : height,'--c-5-4QcjJ': color,'--mt-6-4QcjJ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-7-4QcjJ': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-text ${styles.Text}`}
>
Couldn't load camera
</span>
</div>
{children}
</React.Fragment>)
}